module.exports = __webpack_public_path__ + "static/media/fxsport_signature_gmail.d2ed915f.png";